import axios from 'axios';
import BaseService from "./BaseService";
import settings from "../settings/settings";
import LogUtils from "../utils/LogUtils";
import MsgUtils from "../utils/MsgUtils";

class UserTypesService extends BaseService {

  constructor() {
    super();
    this.TAG = "UserTypesService";
    this.USER_TYPES = {};
    this.USER_TYPES_NAME_OBJS = {};
    this.ALLOWED_USER_TYPES = {};

    this.msgUtils = new MsgUtils();
    this.logUtils = new LogUtils();

    this.setUserTypes();
  }

  setUserTypes() {
    const txts = this.msgUtils.getTxts();
    this.USER_TYPES = {
      USER: {
        name: "user",
        description: txts.LABEL_USER_TYPES.USER
      },
      PLATFORM_USER: {
        name: "platform_user",
        description: txts.LABEL_USER_TYPES.PLATFORM_USER
      },
      ADMIN: {
        name: "admin",
        description: txts.LABEL_USER_TYPES.ADMIN
      },
      AGENTS_MANAGER: {
        name: "agent_manager",
        description: txts.LABEL_USER_TYPES.AGENTS_MANAGER
      },
      AGENT: {
        name: "agent",
        description: txts.LABEL_USER_TYPES.AGENT
      },
      RESEARCHER: {
        name: "researcher",
        description: txts.LABEL_USER_TYPES.RESEARCHER
      },
      POPULATION: {
        name: "population",
        description: txts.LABEL_USER_TYPES.POPULATION
      }
    }

    this.USER_TYPES_NAME_OBJS[this.USER_TYPES.USER.name] = this.USER_TYPES.USER;
    this.USER_TYPES_NAME_OBJS[this.USER_TYPES.PLATFORM_USER.name] = this.USER_TYPES.PLATFORM_USER;
    this.USER_TYPES_NAME_OBJS[this.USER_TYPES.ADMIN.name] = this.USER_TYPES.ADMIN;
    this.USER_TYPES_NAME_OBJS[this.USER_TYPES.AGENTS_MANAGER.name] = this.USER_TYPES.AGENTS_MANAGER;
    this.USER_TYPES_NAME_OBJS[this.USER_TYPES.AGENT.name] = this.USER_TYPES.AGENT;
    this.USER_TYPES_NAME_OBJS[this.USER_TYPES.RESEARCHER.name] = this.USER_TYPES.RESEARCHER;
    this.USER_TYPES_NAME_OBJS[this.USER_TYPES.POPULATION.name] = this.USER_TYPES.POPULATION;

    this.ALLOWED_USER_TYPES[this.USER_TYPES.AGENT.name] = this.USER_TYPES.AGENT;
  }

  async getUserTypes() {
    let userTypesList = [];

    try {
      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.GET,
        `${settings.MANAGEMENT_SERVICE_URL}/user-types`,
        this.getDefaultHeaders(true)
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: "Não foi possível retornar a lista de tipos de usuários"
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível retornar a lista de tipos de usuários"
        };
      }

      userTypesList = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getUserTypes", err);

      return {
        status: -2,
        msg: this.parseError(err)
      };
    }

    return {
      status: 1,
      msg: "A lista de tipos de usuários foi retornada com sucesso",
      data: userTypesList
    };
  }

  getSelectedUserType(userTypeId, userTypes) {
    try {
      let selectedUserType = null;

      userTypes.forEach((userType) => {
        if (userType && userTypeId === userType.id) {
          selectedUserType = userType;
        }
      });

      return selectedUserType;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Failed to getSelectedUserType", err);
    }

    return null;
  }

}

export default UserTypesService;